module.exports = __webpack_public_path__ + "img/akkodis-brand-logo.828d4245.svg";